var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5457_330043)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17.5C17 16.5717 17.3687 15.6815 18.0251 15.0251C18.6815 14.3687 19.5717 14 20.5 14H24V21H20.5C19.5717 21 18.6815 20.6313 18.0251 19.9749C17.3687 19.3185 17 18.4283 17 17.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 14H27.5C27.9596 14 28.4148 14.0905 28.8394 14.2664C29.264 14.4423 29.6499 14.7001 29.9749 15.0251C30.2999 15.3501 30.5577 15.736 30.7336 16.1606C30.9095 16.5852 31 17.0404 31 17.5C31 17.9596 30.9095 18.4148 30.7336 18.8394C30.5577 19.264 30.2999 19.6499 29.9749 19.9749C29.6499 20.2999 29.264 20.5577 28.8394 20.7336C28.4148 20.9095 27.9596 21 27.5 21H24V14Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 24.5C24 24.0404 24.0905 23.5852 24.2664 23.1606C24.4423 22.736 24.7001 22.3501 25.0251 22.0251C25.3501 21.7001 25.736 21.4423 26.1606 21.2664C26.5852 21.0905 27.0404 21 27.5 21C27.9596 21 28.4148 21.0905 28.8394 21.2664C29.264 21.4423 29.6499 21.7001 29.9749 22.0251C30.2999 22.3501 30.5577 22.736 30.7336 23.1606C30.9095 23.5852 31 24.0404 31 24.5C31 24.9596 30.9095 25.4148 30.7336 25.8394C30.5577 26.264 30.2999 26.6499 29.9749 26.9749C29.6499 27.2999 29.264 27.5577 28.8394 27.7336C28.4148 27.9095 27.9596 28 27.5 28C27.0404 28 26.5852 27.9095 26.1606 27.7336C25.736 27.5577 25.3501 27.2999 25.0251 26.9749C24.7001 26.6499 24.4423 26.264 24.2664 25.8394C24.0905 25.4148 24 24.9596 24 24.5V24.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 31.5C17 30.5717 17.3687 29.6815 18.0251 29.0251C18.6815 28.3687 19.5717 28 20.5 28H24V31.5C24 32.4283 23.6313 33.3185 22.9749 33.9749C22.3185 34.6313 21.4283 35 20.5 35C19.5717 35 18.6815 34.6313 18.0251 33.9749C17.3687 33.3185 17 32.4283 17 31.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 24.5C17 23.5717 17.3687 22.6815 18.0251 22.0251C18.6815 21.3687 19.5717 21 20.5 21H24V28H20.5C19.5717 28 18.6815 27.6313 18.0251 26.9749C17.3687 26.3185 17 25.4283 17 24.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5457_330043",
    x: -8,
    y: -8,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5457_330043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5457_330043",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFigma);
export default __webpack_public_path__ + "static/media/upload-figma.7398b52368ad71b3173e5d69a659a597.svg";
export { ForwardRef as ReactComponent };